export default __webpack_public_path__ + "static/media/Group 1302.b4e2bf2d.png";